
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useIsMobile } from "@/hooks/use-mobile";
import { useDebugMode } from "@/hooks/login/useDebugMode";
import { LoginForm } from "@/components/login";
import DebugSection from "@/components/login/DebugSection";

const Login = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const isMobile = useIsMobile();
  const { 
    showDebugInfo, 
    debugOutput, 
    toggleDebugMode, 
    setShowDebugInfo,
    checkEmployees,
    isLoading
  } = useDebugMode();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className={`min-h-screen flex items-center justify-center bg-luijten-gray ${isMobile ? 'p-4' : ''}`}>
      <div className="w-full max-w-md">
        <LoginForm onDebugClick={toggleDebugMode} />
        
        {showDebugInfo && (
          <div className="mt-4 bg-white rounded-lg shadow-sm p-4 border rounded-lg">
            <DebugSection 
              showDebugInfo={showDebugInfo}
              setShowDebugInfo={setShowDebugInfo}
              debugOutput={debugOutput}
              checkEmployees={checkEmployees}
              isLoading={isLoading}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
